import React from "react";
import { Helmet } from "react-helmet";
import { Route, Redirect } from "react-router-dom";
import { useUser } from "../../contexts/user";
import { hasDashboardPermission } from "../../utils";
import Loader from "../loader/loader";

type Props = {
  title: string;
  exact: boolean;
  path: any;
  component: React.FC;
};

const AuthPage: React.FC<Props> = ({ title, exact, path, component }) => {
  const [user] = useUser();

  return (
    <Loader
      full
      loading={!user || user.user?.id === "" || user.order.id === ""}
    >
      <Helmet>
        <title>{title || "Pixlip"}</title>
      </Helmet>
      {hasDashboardPermission(user?.user) ? (
        <Redirect to="/dashboard" />
      ) : user.order.id !== "not_found" ? (
        <Redirect to="/" />
      ) : (
        <Route exact={exact} path={path} component={component} />
      )}
    </Loader>
  );
};

export default AuthPage;
